import { useEffect, useRef } from "react";
import client from "socket.io-client";
// https://admin.bottax.tech/
// https://admin.gptlegal.pro/
const SOCKET_URL = 'https://admin.bottax.tech/';

function getDeviceId() {
    // normalize to camelCase key used across the app
    let id = localStorage.getItem('deviceId');
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem('deviceId', id);
    }
    return id;
}

function getDeviceType() {
    const ua = navigator.userAgent.toLowerCase();

    if (/ipad|tablet/.test(ua)) return 'tablet';
    if (/mobi|android|iphone/.test(ua)) return 'mobile';
    return 'desktop';
}


export function useSocket(auth) {
    const socketRef = useRef(null);

    useEffect(() => {
        if (!auth?.userId) return;

        const deviceId = getDeviceId();
        const typeDevice = getDeviceType();

        socketRef.current = client(SOCKET_URL, {
            transports: ['websocket'],
            auth: {
                userId: auth.userId,
                deviceId,
                typeDevice,
            }
        });

        socketRef.current.on('connect', () => {
            //console.log('Socket connected', socketRef.current.id);
        });

        socketRef.current.on('connect_error', (err) => {
            console.error('Socket error:', err.message);
        });

        return () => {
            socketRef.current?.disconnect();
            socketRef.current = null;
        };
    }, [auth?.userId]);

    return {
        socket: socketRef.current
    };
}
